import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Signup from '../views/auth/Signup.vue'
import Login from '../views/auth/Login.vue'
import Logout from '../views/auth/Logout.vue'
import Shop from '../views/ShoppingCartView.vue'
import Checkout from '../views/CheckoutView.vue'
import Payment from '../views/PaymentView.vue'
import Appointment from '../views/AppointmentView.vue'
import InfoRequest from '../views/InfoRequestView.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/en',
    name: 'Home EN',
    component: Home
  },
  {
    path: '/nl',
    name: 'Home NL',
    component: Home
  },
  {
    path: '/shop',
    name: 'Shop',
    component: Shop
  },
  {
    path: '/appointment',
    name: 'Appointment',
    component: Appointment
  },
  {
    path: '/request',
    name: 'InfoRequest',
    component: InfoRequest
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: Checkout,
    meta: { transition: 'slide-left' }
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup
  },
  {
    path: '/payment',
    name: 'Payment',
    component: Payment
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
